<template>
  <div id="mian">
    <div class="slogn">
      <img src="~assets/img/slogn.png"
           alt />
    </div>
    <!-- ------------ -->
    <div class="login"
         style>
      <h2 class="tital-text">登陆 Traver 工作台</h2>
      <el-form :model="formData">
        <el-input style="width: 355px; margin-top: 10px"
                  v-model="formData.username"
                  placeholder="请输入用户名或邮箱"
                  prefix-icon="el-icon-user"></el-input>

        <el-form-item style="width: 355px; margin-top: 20px">
          <el-input placeholder="请输入密码"
                    v-model="formData.password"
                    prefix-icon="el-icon-unlock
                    "
                    show-password></el-input>
        </el-form-item>
        <div style="width: 355px; margin-top: 20px">
          <el-button @click.prevent="handleLogin()"
                     style="width: 355px"
                     type="primary">登陆</el-button>
        </div>
        <div style="margin-top: 20px; margin-bottom: 10px">
          <el-checkbox v-model="remember">记住用户名密码</el-checkbox>
          <div class="login-text">
            <el-link style="margin: 0px 10px"
                     type="primary">忘记密码</el-link>
            <p>|</p>
            <el-link @click="handleToRegister()"
                     style="margin-left: 10px"
                     type="primary">新用户注册</el-link>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 备案信息 -->
    <copy-right></copy-right>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Base64 } from 'js-base64'
import CopyRightAndWebInfor from '../../components/common/CopyRightAndWebInfor'
export default {
  name: 'Login',
  components: {
    'copy-right': CopyRightAndWebInfor,
  },
  data() {
    return {
      formData: {
        username: '',
        password: '',
      },
      remember: null, //是否记住密码
    }
  },
  computed: {
    ...mapState(['hasLogin', 'userINfo']),
  },
  created() {
    // // 在页面加载时从cookie获取登录信息
    let username = this.$cookies.get('username')
    let password_base = this.$cookies.get('password')
    let password
    if (password_base) {
      password = Base64.decode(password_base)
    }
    // // 如果存在赋值给表单，并且将记住密码勾选
    if (username) {
      this.formData.username = username
      this.formData.password = password
      this.remember = true
    }
  },
  methods: {
    ...mapMutations(['login', 'logout']),
    handleToRegister() {
      this.$router.push({ path: '/register' })
    },
    // 点击登陆
    handleLogin() {
      // 判断是否记住密码
      if (this.remember) {
        let password = Base64.encode(this.formData.password)
        this.setCookie(this.formData.username, password, 7)
      } else {
      }
      this.$http.post('/login', this.formData).then((res) => {
        // console.log('res')
        const { errmsg, errno, data } = res.data

        // this.$cookies.set("登陆时设置了一个cookie", res.headers);
        if (errno === '0') {
          this.login(data)
          this.$message.success(errmsg)
          this.$router.push({ path: '/booking_data' })
        } else if (errno === '4101') {
          this.$message.warning(errmsg)
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
    },
    setCookie(userame, password, expiredays) {
      var exdate = new Date() // 创建时间对象
      exdate.setDate(exdate.getDate() + expiredays)

      this.$cookies.set('username', userame, exdate.toGMTString())
      this.$cookies.set('password', password, exdate.toGMTString())
    },
  },
}
</script>

<style>
#mian {
  position: absolute;
  background-color: #ff5421;
  height: 100%;
  width: 100%;
  overflow: auto;
  background-size: cover;
}

.slogn img {
  position: absolute;
  border: 2px solid rgb(255, 255, 255);
  margin-top: 15%;
  margin-left: 10%;
  width: 30%;
  height: auto;
}

.login {
  position: relative;
  left: 50%;
  width: 350px;
  height: 280 px;
  padding: 20px 50px;
  background: #ffffff;
  border-radius: 5px;

  position: relative;

  margin-top: 10%;
  margin-left: 5%;
  margin-right: auto;
  background: #fff;
  margin-bottom: 50px;
}

.forDiv h2 {
  padding: 10px 0 20px;
  font-size: 20px;
  color: #545454;
}

.tital-text {
  text-align: center;
  font-size: 23px;
  margin: 20px 0 10px;
  padding: 10px 0 20px;
  font-style: unset;
  font-family: Arial, Helvetica, sans-serif;
  color: #545454;
}

.login-text {
  display: flex;
  float: right;
}
</style>